import { SyntheticEvent, useState } from 'react'
import createFunction from '../crudFunctions/createFunction'
import { client } from '../../interfaces'

interface props {
  setShowClientModal: React.Dispatch<React.SetStateAction<boolean>>
  trigger: boolean
  setTrigger: React.Dispatch<React.SetStateAction<boolean>>
}

const NewClientModal = ({ setShowClientModal, trigger, setTrigger }: props) => {
  const [newClient, setNewClient] = useState<string>('')
  const [newClientPhone, setNewClientPhone] = useState<string>('')
  const [error, setError] = useState<string>('')

  const handleSubmit = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (!newClient || !newClientPhone) {
      setError('Debes llenar ambos campos')
    } else {
      const clientObj: client = { name: newClient, phone: newClientPhone }
      const body: string = JSON.stringify(clientObj)
      createFunction('client/create', body).then((response: client) => {
        if (!response) {
          setError('Ya hay un cliente con ese numero')
        } else {
          setTrigger(!trigger)
          setShowClientModal(false)
        }
      })
    }
  }

  return (
    <>
      <div id='newClientModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <form className='grid' onSubmit={handleSubmit}>
            <label htmlFor='newClient' className='text-lg'>
              Nombre
            </label>
            <input
              type='text'
              name='newClient'
              id='newClient'
              className='border-2 border-black rounded-md text-center'
              onChange={(e) => setNewClient(e.target.value)}
            />

            <label htmlFor='newClientPhone' className='text-lg mt-8'>
              Teléfono
            </label>
            <input
              type='text'
              value={newClientPhone}
              name='newClientPhone'
              id='newClientPhone'
              className='border-2 border-black rounded-md text-center'
              onChange={(e) => {
                setNewClientPhone(e.target.value.replace(/\D/, ''))
              }}
            />
            {error && (
              <h2 className='text-lg text-center text-red-500'>{error}</h2>
            )}
            <button
              type='submit'
              className='bg-viper  text-white text-xl rounded-lg w-3/4 place-self-center px-8 py-2 mt-10 shadow-lg'>
              <span>Guardar</span>
            </button>
          </form>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-20 shadow-lg'
            onClick={() => setShowClientModal(false)}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default NewClientModal
